var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layer',{attrs:{"visible":_vm.visible}},[_c('div',{staticClass:"dlrLayer-mask bgZero",on:{"touchstart":_vm.toast,"touchmove":_vm.toast,"click":_vm.toast,"mousemove":_vm.toast}})])}
var staticRenderFns = []

export { render, staticRenderFns }